export default __webpack_public_path__ + "static/media/Aeonik-BoldItalic.59057266.woff2";